import React, { useEffect } from "react"
import { Container } from "@mui/material"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { isMobile } from "react-device-detect"
import throttle from "lodash"
import styles from "pages/Plans/Plans.module.scss"
import LayoutWithModal from "components/Layout/LayoutWithModal"
import CommonStepBar from "components/common/CommonStepBar"
import CommonTitle from "components/common/CommonTitle"
import PlanCard from "components/PlanCard"
import Pagination from "components/Pagination"
import PlanBody from "components/PlanBody"
import ScaledDownCard from "components/ScaledDownCard"
import RightArrowButton from "components/Button/RightArrowButton"
import { useDeviceType } from "utils/MediaQuery"
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos"
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos"
import ArrowBackIcon from "@mui/icons-material/ArrowBack"
import planActions from "store/actions/PlanAction"
import { APP_URL, Colors, PLANLIST, PLANS } from "Const"
import { EasyCalcResIf } from "utils/ifs/EasyCalcRes"
import { AppState } from "store/store"
import { getCompStartDate, loadResponseEasyCalc } from "utils/JsonManipulation"
import GoBackButton from "components/Button/GoBackButton"
import { modalSelector, MODAL_TYPE } from "components/Modal/ModalSelector"

export const PAGE = {
  LIGHT: -1,
  STANDARD: 0,
  FULLSUPPORT: 1
}
const MOVE = {
  RIGHT: 1,
  LEFT: -1
}
let responseData = {
  light: { pricing: { oneTime: {}, totalInstallments: {}, firstInstallments: {} } },
  standard: { pricing: { oneTime: {}, totalInstallments: {}, firstInstallments: {} } },
  fullSupport: { pricing: { oneTime: {}, totalInstallments: {}, firstInstallments: {} } }
}
/**
 * Step4 見積結果表示画面
 * 簡易見積もりAPIからのレスポンスを表示
 */
const Plans = () => {
  const dispatch = useDispatch()
  const { isSmartPhone } = useDeviceType()
  const [isSmallCard, setIsSmallCard] = React.useState(false)
  const [isButtonFixed, setIsButtonFixed] = React.useState(true)
  const navigate = useNavigate()
  const pageInStore = useSelector((state: AppState) => state.plan.page)
  const getPageForScroll = (pageInApi: string) => {
    // "3":ライトプラン → LIGHT: -1
    if (pageInApi === PLANS.LIGHT) return PAGE.LIGHT
    // "2": 通常プラン → STANDARD: 0
    if (pageInApi === PLANS.STANDARD) return PAGE.STANDARD
    // "1": 充実プラン → FULLSUPPORT: 1
    if (pageInApi === PLANS.FULLSUPPORT) return PAGE.FULLSUPPORT
    return PAGE.LIGHT
  }
  const [page, setPage] = React.useState(pageInStore ? getPageForScroll(pageInStore) : PAGE.LIGHT)
  const [isAnnual, setIsAnnual] = React.useState(true) // 一括・分割払
  const [openModal, setOpenModal] = React.useState(false)
  const [modalType, setModalType] = React.useState("")
  let isComponentWillUnmount = false
  const res: EasyCalcResIf = useSelector((state: AppState) => state.plan.plan)
  const getToday = () => {
    const today = new Date()
    return `${today.getFullYear()}年${today.getMonth() + 1}月${today.getDate()}日`
  }
  const formatDate = (date: Date) => {
    return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`
  }
  // 横スクロール処理（PC向け処理）
  const animationBreak = 300
  const wheelStrength = 20
  let prevDelta = 0
  const scrollXByWheel = throttle.throttle(
    (e: React.WheelEvent<HTMLDivElement>) => {
      console.log("------- START -------")
      console.log("prevDelta: ", prevDelta)
      console.log("e.deltaX: ", e.deltaX)
      console.log("prevDelta > e.deltaX + wheelStrength: ", prevDelta > e.deltaX + wheelStrength)
      console.log("-------- END --------")
      if (e.deltaX > 1 && prevDelta > e.deltaX + wheelStrength) {
        setPage(page < PAGE.FULLSUPPORT ? page + MOVE.RIGHT : page)
        prevDelta = 0
      } else if (e.deltaX < -1 && prevDelta < e.deltaX - wheelStrength) {
        setPage(page > PAGE.LIGHT ? page + MOVE.LEFT : page)
        prevDelta = 0
      } else {
        prevDelta = e.deltaX
      }
    },
    animationBreak,
    { leading: false, trailing: true }
  )
  // スワイプ処理（スマホ向け処理）
  let startX = 0
  let endX = 0
  let startY = 0
  let endY = 0
  const touchMoveStrength = window.innerWidth / 3
  const onTouchStart = (e: React.TouchEvent<Element>) => {
    startX = e.changedTouches[0].pageX
    startY = e.changedTouches[0].pageY
    endX = 0
    endY = 0
  }
  const onTouchEnd = (e: React.TouchEvent<Element>) => {
    endX = e.changedTouches[0].pageX
    endY = e.changedTouches[0].pageY
    console.log("------- START -------")
    console.log("StartX: ", startX)
    console.log("endX: ", endX)
    console.log("endX - startX: ", endX - startX)
    console.log("StartY: ", startY)
    console.log("endY: ", endY)
    console.log("Math.abs(startY - endY): ", Math.abs(startY - endY))
    console.log("-------- END --------")
    const isEnoughToGoLeft = endX - startX > Math.abs(startY - endY) && endX - startX > touchMoveStrength
    const isEnoughToGoRight = startX - endX > Math.abs(startY - endY) && startX - endX > touchMoveStrength
    if (startX < endX && isEnoughToGoLeft) {
      setPage(page > PAGE.LIGHT ? page + MOVE.LEFT : page)
      startX = 0
      startY = 0
    } else if (startX > endX && isEnoughToGoRight) {
      setPage(page < PAGE.FULLSUPPORT ? page + MOVE.RIGHT : page)
      startX = 0
      startY = 0
    }
  }
  // ボタンによる左右スクロール移動処理
  const scrollXByButton = (goRight: boolean) => {
    if (goRight) {
      setPage(page < PAGE.FULLSUPPORT ? page + MOVE.RIGHT : page)
    } else {
      setPage(page > PAGE.LIGHT ? page + MOVE.LEFT : page)
    }
  }
  const CardTransitionPointRef = React.useRef<HTMLDivElement>(null)
  const PlanRootRef = React.useRef<HTMLDivElement>(null)
  const onScroll = () => {
    const cardTransitionPoint = CardTransitionPointRef.current
    const cardTop = cardTransitionPoint ? cardTransitionPoint.getBoundingClientRect().top : 1
    if (cardTop < 0) {
      setIsSmallCard(true)
    } else {
      setIsSmallCard(false)
    }
    const root = PlanRootRef.current
    const rootBottom = root ? root.getBoundingClientRect().bottom : 0
    const distanceToGoBackButton = 150
    if (rootBottom < window.innerHeight + distanceToGoBackButton) {
      setIsButtonFixed(false)
    } else {
      setIsButtonFixed(true)
    }
  }
  const translateXCard = (x: number) => {
    return isSmartPhone
      ? { transform: `translate3d(${x * -100}vw, 0, 0)` }
      : { transform: `translate3d(${x * -360}px, 0, 0)` }
  }
  const translateXBody = (x: number) => {
    return isSmartPhone
      ? { transform: `translate3d(${x * -100}vw, 0, 0)` }
      : { transform: `translate3d(${x * -640}px, 0, 0)` }
  }
  const getCardBorderColor = (isFocused: boolean) => {
    return isFocused ? styles.borderOrange : {}
  }
  const getPageValueForAPI = (pageNum: number) => {
    // LIGHT: -1 → "3":ライトプラン
    if (pageNum === PAGE.LIGHT) return "3"
    // STANDARD: 0 → "2": 通常プラン
    if (pageNum === PAGE.STANDARD) return "2"
    // FULLSUPPORT: 1 → "1": 充実プラン
    if (pageNum === PAGE.FULLSUPPORT) return "1"
    return ""
  }
  // componentDidMount
  useEffect(() => {
    if (!isComponentWillUnmount) {
      window.addEventListener("scroll", onScroll)
    }
    if (res.EASIMessage) {
      responseData = loadResponseEasyCalc(res)
    } else {
      // キャッシュにプランの情報がなければ、トップページへ
      navigate(APP_URL.TOP)
    }
  }, [])
  // componentWillUnmount
  useEffect(() => {
    if (isComponentWillUnmount) {
      window.removeEventListener("scroll", onScroll)
    }
  }, [])
  const onClickSubmit = () => {
    const pricing = () => {
      if (page === PAGE.STANDARD) {
        return isAnnual
          ? responseData.standard.pricing.oneTime.toString()
          : responseData.standard.pricing.totalInstallments.toString()
      }
      if (page === PAGE.LIGHT) {
        return isAnnual
          ? responseData.light.pricing.oneTime.toString()
          : responseData.light.pricing.totalInstallments.toString()
      }
      return isAnnual
        ? responseData.fullSupport.pricing.oneTime.toString()
        : responseData.fullSupport.pricing.totalInstallments.toString()
    }
    navigate(APP_URL.COMPLETE, {
      state: { page: getPageValueForAPI(page), pricing: pricing() }
    })
    dispatch(planActions.updatePage(getPageValueForAPI(page)))
    isComponentWillUnmount = true
  }
  const renderPlan = () => {
    return (
      <LayoutWithModal
        openModal={openModal}
        closeModal={() => {
          setOpenModal(false)
        }}
        innerContents={modalSelector(modalType)}
      >
        <div className={styles.root}>
          <CommonStepBar num={4} />
          <CommonTitle titles={["お見積り結果"]} read="" />
          {isSmallCard && page === PAGE.LIGHT && (
            <ScaledDownCard
              currentPage={page}
              plan={PLANLIST.LIGHT}
              pricing={
                isAnnual
                  ? responseData.light.pricing.oneTime.toString()
                  : responseData.light.pricing.firstInstallments.toString()
              }
              scrollX={scrollXByButton}
              isAnnual={isAnnual}
            />
          )}
          {isSmallCard && page === PAGE.STANDARD && (
            <ScaledDownCard
              currentPage={page}
              plan={PLANLIST.NORMAL}
              pricing={
                isAnnual
                  ? responseData.standard.pricing.oneTime.toString()
                  : responseData.standard.pricing.firstInstallments.toString()
              }
              scrollX={scrollXByButton}
              isAnnual={isAnnual}
            />
          )}
          {isSmallCard && page === PAGE.FULLSUPPORT && (
            <ScaledDownCard
              currentPage={page}
              plan={PLANLIST.PREMIUM}
              pricing={
                isAnnual
                  ? responseData.fullSupport.pricing.oneTime.toString()
                  : responseData.fullSupport.pricing.firstInstallments.toString()
              }
              scrollX={scrollXByButton}
              isAnnual={isAnnual}
            />
          )}
          <div id="planRoot" ref={PlanRootRef}>
            <div className={styles.explanation}>
              <span>
                3つのプラン（ライト・スタンダード・フルサポート）の概算お見積りをご用意いたしました。
                <br />
                ご希望に近いプランをマイページに保存いただくと、より詳細な補償内容のカスタマイズやお申込みができます。
                <br />
                <br />
                <span style={{ fontFamily: "Meiryo, メイリオ" }}>※</span>保険期間：{formatDate(getCompStartDate())}
                から1年間
                <br />
              </span>
            </div>
            <div
              className={styles.planContainer}
              onWheel={(e) => {
                if (!isMobile) {
                  scrollXByWheel(e)
                }
              }}
              onTouchStart={(e) => {
                if (isMobile) {
                  onTouchStart(e)
                }
              }}
              onTouchEnd={(e) => {
                if (isMobile) {
                  onTouchEnd(e)
                }
              }}
            >
              {!isSmartPhone && (
                <>
                  <div
                    role="button"
                    tabIndex={0}
                    className={styles.planContainer__leftArrow}
                    style={page === PAGE.LIGHT ? { opacity: 0 } : {}}
                    onClick={() => {
                      scrollXByButton(false)
                    }}
                    onKeyDown={() => {}}
                  >
                    <ArrowBackIosIcon style={{ color: Colors.Orange }} />
                  </div>
                  <div
                    role="button"
                    tabIndex={0}
                    className={styles.planContainer__rightArrow}
                    style={page === PAGE.FULLSUPPORT ? { opacity: 0 } : {}}
                    onClick={() => {
                      scrollXByButton(true)
                    }}
                    onKeyDown={() => {}}
                  >
                    <ArrowForwardIosIcon style={{ color: Colors.Orange }} />
                  </div>
                </>
              )}
              <div className={styles.planContainer__cards} style={translateXCard(page)}>
                <div
                  className={`${styles.planContainer__card} ${getCardBorderColor(page === PAGE.LIGHT)}`}
                  style={!isSmartPhone && page !== PAGE.LIGHT ? { opacity: 0.4 } : {}}
                >
                  <PlanCard
                    currentPage={page}
                    plan={PLANLIST.LIGHT}
                    title="ライトプラン"
                    scrollX={scrollXByButton}
                    isAnnual={isAnnual}
                    setIsAnnual={setIsAnnual}
                    ref={CardTransitionPointRef}
                  />
                </div>
                <div
                  className={`${styles.planContainer__card} ${getCardBorderColor(page === PAGE.STANDARD)}`}
                  style={!isSmartPhone && page !== PAGE.STANDARD ? { opacity: 0.4 } : {}}
                >
                  <PlanCard
                    currentPage={page}
                    plan={PLANLIST.NORMAL}
                    title="スタンダードプラン"
                    scrollX={scrollXByButton}
                    isAnnual={isAnnual}
                    setIsAnnual={setIsAnnual}
                    ref={CardTransitionPointRef}
                  />
                </div>
                <div
                  className={`${styles.planContainer__card} ${getCardBorderColor(page === PAGE.FULLSUPPORT)}`}
                  style={!isSmartPhone && page !== PAGE.FULLSUPPORT ? { opacity: 0.4 } : {}}
                >
                  <PlanCard
                    currentPage={page}
                    plan={PLANLIST.PREMIUM}
                    title="フルサポートプラン"
                    scrollX={scrollXByButton}
                    isAnnual={isAnnual}
                    setIsAnnual={setIsAnnual}
                    ref={CardTransitionPointRef}
                  />
                </div>
              </div>
            </div>
            <Pagination page={page} />
            <div className={styles.modalCondList}>
              {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
              <div
                role="button"
                tabIndex={0}
                onClick={() => {
                  setOpenModal(true)
                  setModalType(MODAL_TYPE.CONDITION_LIST)
                }}
              >
                お見積り条件を確認する
              </div>
            </div>
            <div
              className={styles.planContainer}
              onWheel={(e) => {
                if (!isMobile) {
                  scrollXByWheel(e)
                }
              }}
              onTouchStart={(e) => {
                if (isMobile) {
                  onTouchStart(e)
                }
              }}
              onTouchEnd={(e) => {
                if (isMobile) {
                  onTouchEnd(e)
                }
              }}
            >
              <div className={styles.planContainer__bodies} style={translateXBody(page)}>
                <div
                  className={styles.planContainer__body}
                  style={!isSmartPhone && page !== PAGE.LIGHT ? { opacity: 0 } : {}}
                >
                  <PlanBody plan="light" isAnnual={isAnnual} setOpenModal={setOpenModal} setModalType={setModalType} />
                </div>
                <div
                  className={styles.planContainer__body}
                  style={!isSmartPhone && page !== PAGE.STANDARD ? { opacity: 0 } : {}}
                >
                  <PlanBody
                    plan="standard"
                    isAnnual={isAnnual}
                    setOpenModal={setOpenModal}
                    setModalType={setModalType}
                  />
                </div>
                <div
                  className={styles.planContainer__body}
                  style={!isSmartPhone && page !== PAGE.FULLSUPPORT ? { opacity: 0 } : {}}
                >
                  <PlanBody
                    plan="fullSupport"
                    isAnnual={isAnnual}
                    setOpenModal={setOpenModal}
                    setModalType={setModalType}
                  />
                </div>
              </div>
            </div>
            <div className={styles.cautions}>
              上記の保険料は、{getToday()}
              のものです。
            </div>
            {isButtonFixed && (
              <div className={styles.fixed}>
                <div className={`${styles.saveButtonWrap}`}>
                  <RightArrowButton
                    color={Colors.White}
                    arrowColor={Colors.Orange}
                    text="このプランのお見積りを保存"
                    onClick={onClickSubmit}
                    isSquareOnPC={false}
                  />
                </div>
              </div>
            )}
            <div className={`${styles.saveButtonWrap}`} style={isButtonFixed ? { opacity: 0 } : { opacity: 1 }}>
              <RightArrowButton
                color={Colors.White}
                arrowColor={Colors.Orange}
                text="このプランのお見積りを保存"
                onClick={onClickSubmit}
                isSquareOnPC={false}
              />
            </div>
            <GoBackButton
              where={APP_URL.CONDITIONS}
              onClick={() => {
                isComponentWillUnmount = true
              }}
            />
          </div>
        </div>
      </LayoutWithModal>
    )
  }
  return res.EASIMessage ? renderPlan() : <> </>
}
export default Plans
